import { useTheme } from '@simplywallst/ui-core';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import Media from 'react-media';
import MobileTopbarSubNav, { ListItem } from '@components/MobileTopbarSubNav';
import type { CompanyReportSection } from '../../useSection';
import { MobileNavigationWrapper, NavButton } from './styled';
import { useCompanyReportPageUrl } from '../../hooks/useCompanyReportPageUrl';
import { useRoutes } from '../../constants/routes';

import { useCompanyCountryMatch } from '@/pages/StockPage/hooks/useCompanyCountryMatch';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany/useCompanyCanonicalUrl';

function NavigationMobile({
  section,
  onSectionChange,
}: {
  section: CompanyReportSection;
  onSectionChange?: (section: CompanyReportSection) => void;
}) {
  const theme = useTheme();
  const { isMobile, isTablet } = useUserAgent();
  const companyUrl = useCompanyReportPageUrl();

  const routes = useRoutes();

  const canonicalUrl = useCompanyCanonicalUrl();

  const { isMatch, stockUrl } = useCompanyCountryMatch(canonicalUrl, 'CA');

  return (
    <Media
      query={{ maxWidth: theme.mdMaxRaw }}
      defaultMatches={isMobile || isTablet}
    >
      {(matches) =>
        matches && (
          <MobileNavigationWrapper data-cy-id="mobile-navigation-wrapper">
            <MobileTopbarSubNav
              routes={routes}
              selected={section}
              renderInPortal={false}
            >
              {({ routes, handleClick, refMap, selected }) => (
                <>
                  {routes.map(({ anchor, label, tracking }, i) => (
                    <ListItem
                      ref={refMap[i]}
                      key={`MobileTopbarListItem-${anchor}-${i}`}
                      selected={selected === anchor}
                    >
                      <NavButton
                        data-cy-id={`mobile-topbar-nav-${i}`}
                        to={`${companyUrl}${
                          anchor === 'summary' ? '' : `/${anchor}`
                        }`}
                        onClick={(e) => {
                          // This prevents the link from pushing to window.history
                          // we will let the parent handle it via handleClick instead
                          e.preventDefault();
                          e.stopPropagation();
                          handleClick(tracking || label, anchor);
                          anchor &&
                            onSectionChange?.(anchor as CompanyReportSection);
                        }}
                      >
                        {label}
                      </NavButton>
                    </ListItem>
                  ))}
                  {isMatch && (
                    <ListItem selected={false}>
                      <NavButton to={stockUrl}>
                        <div>View Community</div>
                      </NavButton>
                    </ListItem>
                  )}
                </>
              )}
            </MobileTopbarSubNav>
          </MobileNavigationWrapper>
        )
      }
    </Media>
  );
}
export default NavigationMobile;
